import React, { useMemo, useRef } from 'react';
import { Layout } from 'tea-component';
import { connect } from 'umi';
import { useInitBuriedPointInfo } from '@op/operationLog/buriedPoint';
import ContentBody from '@op/components/ContentBody';
import {
  FilterFixed,
  useFilterDataHook,
} from '../../../components/FilterCommon';
import CardLoading from '../../../components/CardLoading';
import { NO_DATE } from '@op/constants';
import useLanguage from '@op/hooks/useLanguage';
import "./CommonFilter.scss";
import { DBO_GAME } from '@op/utils/format';
// 过滤器
const { Content } = Layout;
const defaultChannel: Array<'steam'> = ['steam'];
function CommonFilter({
  gameInfo,
  wholeGameInfo,
  children,
  title = NO_DATE.EMPTY,
  hasOnlyHours = false,
  steamPerformancePoint,
  confirmCallback,
  tipsText
}: {
  gameInfo: any;
  wholeGameInfo: any;
  children: (props: {
    gameInfo: any;
    wholeGameInfo: any;
    filter: any;
    isNeedTips: boolean;
  }) => JSX.Element | Array<JSX.Element>;
  title: any;
  hasOnlyHours?: boolean;
  steamPerformancePoint?: any;
  confirmCallback?: (value: any) => void;
  tipsText?: string;
}) {
  useInitBuriedPointInfo({ buriedPoint: steamPerformancePoint });
  const scrollBody = useRef(null);
  const { formatMessage } = useLanguage();

  const {
    loading: initLoading,
    filter,
    changeFilter,
    filterOptions,
  } = useFilterDataHook({
    gameInfo,
    hasHero: true,
    pageName: 'SteamPerformance',
  });

  const { isTrueGame, isNeedTips } = useMemo(() => {
    const isTrueGame =
      DBO_GAME.isHigh(wholeGameInfo) &&
      wholeGameInfo?.entity_type === 'pc' &&
      title === 'Steam Ratings';

    return {
      isNeedTips: isTrueGame && filter?.date_type === 'hourly',
      isTrueGame,
    };
  }, [wholeGameInfo, filter]);



  return (
    <Content className="dbo-page" ref={scrollBody}>
      <ContentBody
        contentHeard={
          <Content.Header
            title={formatMessage({ id: title })}
            className="dbo-header"
            operation={
              isNeedTips ? (
                <div style={{ fontSize: 14, color: 'rgb(131, 134, 151)' }}>
                  {tipsText}
                </div>
              ) : null
            }
          ></Content.Header>
        }
      >
        <FilterFixed
          filter={filterOptions}
          confirm={(value: any) => { 
            confirmCallback?.({isTrueGame, value});

            changeFilter({
              ...value,
              ...gameInfo,
              channel: defaultChannel,
              channel_type: 'comments',
              steam_filter_type: 'steam',
            });
          }}
          defaultValue={{
            date_type: hasOnlyHours ? 'hourly' : 'daily',
          }}
          finallyDealwithDefaultValue={(value: any) => {
            if (hasOnlyHours) {
              return { ...value, date_type: 'hourly' };
            }
            if (!isTrueGame && value.date_type === 'hourly') {
              return { ...value, date_type: 'daily' };
            }
            return value;
          }}
          finallyDealwithHistoryValue={(value: any) => {
            if (hasOnlyHours) {
              return { ...value, date_type: 'hourly' };
            }
            return value;
          }}
          isAccountRegion
          defaultConfig={{
            date: { dateTypeList: hasOnlyHours ? ['hour'] : undefined },
          }}
          scrollBody={scrollBody}
          operateShowOptions={['history', 'more', 'save']}
        ></FilterFixed>
        <CardLoading loading={initLoading}>
          {children({ gameInfo, wholeGameInfo, filter, isNeedTips })}
        </CardLoading>
      </ContentBody>
    </Content>
  );
}

export default connect((state: any) => {
  const { opinionCommon, home } = state;

  return {
    gameInfo: opinionCommon.gameInfo,
    wholeGameInfo: opinionCommon.wholeGameInfo,
    userInfo: home.userInfo,
  };
})(CommonFilter);
